export const open_route_service_api_key = "5b3ce3597851110001cf62482537d142c8ba408fb8e488b3124fe956";
// const sncf_api_key = "b7c4e078-a3af-418c-9e41-43775c6a68af";
export const sncf_api_key = "Basic YjdjNGUwNzgtYTNhZi00MThjLTllNDEtNDM3NzVjNmE2OGFmOg==";
export const openweathermap_api_key = "c591cfc62c234913c64a17ad045799ac";
